import { history } from '../store';

export default mockUserManager => ({
  signinRedirect: args => {
    history.push(args.data.redirectUrl);
  },
  events: {
    addUserLoaded: () => {},
    addSilentRenewError: () => {},
    addAccessTokenExpired: () => {},
    addAccessTokenExpiring: () => {},
    addUserUnloaded: () => {},
    addUserSignedOut: () => {},
    removeUserLoaded: () => {},
    removeSilentRenewError: () => {},
    removeAccessTokenExpired: () => {},
    removeAccessTokenExpiring: () => {},
    removeUserUnloaded: () => {},
    removeUserSignedOut: () => {},
  },
  getUser: async () => {
    console.log('--- User login mocked! ---');
    return {
      token_type: 'Bearer',
      scope: 'openid profile ipa_api3',
      profile: {
        auth_time: new Date().getTime() / 1000,
        idp: 'local',
        amr: ['pwd'],
        role: [
          'Admin',
          'Device Administrator',
          'Cabinet Operator',
          'Administrator',
        ],
        name: 'dev@ipa',
        group: 'SE Dev Team',
      },
      expires_at: new Date().getTime() / 1000 + 3600,
      state: {
        redirectUrl: '/',
      },
    };
  },
});
